import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import { GridActionsCellItemProps } from '@mui/x-data-grid-pro';
import { ReactNode, RefObject } from 'react';

import { BlockedDoubleClickButton } from '../buttons/BlockedDoubleClickButton';

export const ButtonActionItem = ({
	onClick,
	label,
	startIcon,
	ref,
}: Pick<GridActionsCellItemProps, 'showInMenu' | 'label'> & {
	onClick: () => void;
	startIcon: ReactNode;
	ref?: RefObject<HTMLLIElement>;
}): React.JSX.Element => {
	return (
		<MenuItem ref={ref} sx={{ padding: 0 }}>
			<BlockedDoubleClickButton
				variant="text"
				disableRipple
				onClick={onClick}
				sx={{
					flex: '1 1 auto',
					display: 'flex',
					alignItems: 'center',
					padding: (theme) => theme.spacing(0.75, 2),
					textTransform: 'none',
					textAlign: 'left',
					fontSize: '1rem',
				}}>
				<ListItemIcon>{startIcon}</ListItemIcon>
				<ListItemText>{label}</ListItemText>
			</BlockedDoubleClickButton>
		</MenuItem>
	);
};

ButtonActionItem.displayName = 'ButtonActionItem';
